import { useContext } from 'react';
import { AppConfigContext } from './app-config-context';
import type { WebAppConfig } from '../model/types';

export function useAppConfig(): WebAppConfig {
  const config = useContext(AppConfigContext);
  if (!config) {
    throw new Error('useAppConfig must be used within AppConfigProvider');
  }
  return config;
}
